import { onCLS, onLCP, onFCP, onTTFB, onINP } from 'web-vitals'

const reportWebVitals = (onPerfEntry: (metric: unknown) => void) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry)
    onLCP(onPerfEntry)
    onFCP(onPerfEntry)
    onTTFB(onPerfEntry)
    onINP(onPerfEntry) // 🔄 Replaces onFID
  }
}

export default reportWebVitals
